import _extends from "@babel/runtime/helpers/esm/extends";
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { v4 as uuid } from 'uuid';
import { reducer as viewModelReducer } from './view-model/view-model-reducer';
import { reducer as readModelReducer } from './read-model/read-model-reducer';
import createResolveMiddleware from './create-resolve-middleware';
import deserializeInitialState from './internal/deserialize-initial-state';

var createResolveStore = function createResolveStore(resolveContext, params, isClient) {
  if (params === void 0) {
    params = {};
  }

  if (isClient === void 0) {
    isClient = true;
  }

  var sessionId = uuid();
  var viewModels = resolveContext.viewModels;
  var _params = params,
      initialState = _params.initialState,
      serializedState = _params.serializedState,
      _params$redux = _params.redux;
  _params$redux = _params$redux === void 0 ? {} : _params$redux;
  var _params$redux$reducer = _params$redux.reducers,
      reducers = _params$redux$reducer === void 0 ? [] : _params$redux$reducer,
      _params$redux$middlew = _params$redux.middlewares,
      middlewares = _params$redux$middlew === void 0 ? [] : _params$redux$middlew,
      _params$redux$enhance = _params$redux.enhancers,
      enhancers = _params$redux$enhance === void 0 ? [] : _params$redux$enhance,
      _params$redux$sagas = _params$redux.sagas,
      sagas = _params$redux$sagas === void 0 ? [] : _params$redux$sagas;

  if (serializedState != null && initialState != null) {
    throw Error("ambiguous initial state: both initialState and serializedState are set");
  }

  var actualInitialState;

  if (serializedState != null) {
    actualInitialState = deserializeInitialState(viewModels, serializedState);
  } else {
    actualInitialState = initialState;
  }

  var combinedReducers = combineReducers(_extends({}, reducers, {
    viewModels: viewModelReducer,
    readModels: readModelReducer
  }));
  var resolveMiddleware = createResolveMiddleware();
  var appliedMiddlewares = applyMiddleware.apply(void 0, [resolveMiddleware].concat(middlewares));
  var composedEnhancers = compose.apply(void 0, [appliedMiddlewares].concat(enhancers));
  var store = createStore(combinedReducers, actualInitialState, composedEnhancers);
  resolveMiddleware.run(isClient, {
    store: store,
    resolveContext: resolveContext,
    customSagas: sagas,
    sessionId: sessionId
  });
  return store;
};

export { createResolveStore };
//# sourceMappingURL=create-resolve-store.js.map